import { useMemo } from 'react';

import { Y_MAP_DEFAULT_OPTIONS } from '../constants/map';
import { useMapAppContext } from '../context/mapAppContext';

export const useMapInitialOptions = (): YMaps.IMapOptions => {
  const { config } = useMapAppContext();

  return useMemo(() => {
    const constructorOptions = config.get<YMaps.IMapOptions>('search-frontend.yandexMaps.constructorOptions') || {};

    return {
      ...Y_MAP_DEFAULT_OPTIONS,
      ...constructorOptions,
    };
  }, [config]);
};
